import script from "./competitionItem.vue?vue&type=script&setup=true&name=competitionItem&lang=js"
export * from "./competitionItem.vue?vue&type=script&setup=true&name=competitionItem&lang=js"

import "./competitionItem.vue?vue&type=style&index=0&id=4c0726ec&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0726ec"]])

export default __exports__